import { api } from "../api";

export const deleteTagCategory = async (id: string): Promise<void> => {
  await api.services.tagCategories.deleteTagCategory(id);
};
